/**
 * /src/components/utils/formatUtils.js
 *
 * Convert an ISO timestamp (or Date/number) to "YYYY-MM-DD HH:MM" format.
 * Defaults to local time. Pass { utc: true } to format in UTC.
 *
 * Examples:
 *   formatIsoToYMDHM('2023-11-05T14:30:00Z')         // "2023-11-05 07:30" (local)
 *   formatIsoToYMDHM('2023-11-05T14:30:00Z', {utc:true}) // "2023-11-05 14:30"
 */

function pad(n) {
    return String(n).padStart(2, '0');
}

export function isoToLocalDateTime(input, options = { date: true, time: false, seconds: false }) {
    if (input == null || input === '') return '';

    const date = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    let result = '';
    if (options.date) {
        result += `${year}-${pad(month)}-${pad(day)}`;
    }
    if (options.time) {
        if (options.date) result += ' ';
        result += `${pad(hours)}:${pad(minutes)}`;

        if (options.seconds) {
            result += `:${pad(seconds)}`;
        }
    }

    return result;
}

/**
 * Formats a numeric price string with thousand separators.
 *
 * @param {string} priceStr - Price as string (e.g. "1234567.89")
 * @returns {string} Formatted price (e.g. "1,234,567.89")
 */
export function formatPriceWithCommas(priceStr) {
    if (typeof priceStr !== "string") {
        console.error("formatPriceWithCommas expects a string input.");
        return "";
    }

    if (!priceStr.trim()) return "";

    // Remove existing commas (idempotent behavior)
    const normalized = priceStr.replace(/,/g, "");

    // Split integer and decimal parts
    const [integerPart, decimalPart] = normalized.split(".");

    // Add commas to integer part
    const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
    );

    // Pad the decimal part to 2 digits if it exists
    const paddedDecimalPart = decimalPart ? decimalPart.padEnd(2, '0') : '00';

    // Rejoin decimal part if present
    return `${formattedInteger}.${paddedDecimalPart}`;
}


export default {
    isoToLocalDateTime,
    formatPriceWithCommas,
};